import * as React from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { OrganisationMember } from "../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { WizardComponent } from "../../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { ClientRecordAction } from "../Action/ClientRecordAction";
import { ClientRecordTab } from "../Resource/Contents";
import { ClientRecordStore } from "../Store/Variable";
import { AddTrustMemberAction } from "./Action/AddTrustMemberAction";
import { AddTrustMembers } from "./Component/AddTrustMembers";

export class AddTrustMembersWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(ClientRecordStore, () => this.onStoreChange());
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {}

    private onStoreChange() {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation = JSON.parse(JSON.stringify(data[ClientRecordTab.OrganisationDetails]));
            (organisation as Organisation).OrganisationMembers = [];
            (organisation as Organisation).Beneficiaries = [];
            (organisation as Organisation).ShareOfTrustItem = [];
            this.setState({ data: { Organisation: organisation }, isLoading: false });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const id = getQueryParameters()["customerid"];
        ClientRecordAction.getOrganisationDetail(id);
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, params["customerid"]),
            }).TrustServicing
        );
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, onPosting: true });
        const data: Organisation = JSON.parse(JSON.stringify(this.state.data?.Organisation));

        //If new trust members to add already hold relationship to the trust, then existing relationships are not added again
        const existingMembers: OrganisationMember[] = ClientRecordStore.getData()[ClientRecordTab.OrganisationDetails]
            .OrganisationMembers;
        data?.OrganisationMembers.forEach((element) => {
            const existingRelationships = (existingMembers || []).some((x) => x?.CustomerId == element?.CustomerId)
                ? (existingMembers || []).find((x) => x?.CustomerId == element?.CustomerId)?.Relationships
                : [];
            element.Relationships = element.Relationships.filter((x) => !existingRelationships.includes(x));
        });
        AddTrustMemberAction.addTrustMembers(data, (data) => {
            this.setState({ isSubmitting: false, active: true, onPosting: false });
            this.onExit();
        });
    }

    setStepperConfig() {
        this.stepperConfig = [
            {
                title: "Add new trust members",
                url: Urls.get().AddTrustMember,
                path: Contents.URLMap.trustMember,
                canSubmit: () => this.child[0].isValid(),
                onSubmit: () => this.onSubmit(),
                component: <AddTrustMembers {...this.getStepProps(0)} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Add new trust members";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.needSplitHeader = null;
        return processProps;
    }
}
